import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from "react-redux";

import ActionButton from "../../../../Components/Buttons/ActionButton";
import { TabContext } from "../../Pages/BookingsLog";
import { cancelBooking } from "../../Requests/BookingListRequests";
import { UPDATE } from "../../Bookings";
import { formatDuration } from "../../../../Helpers/DateTimeHelper";
import StandardTooltip from "../../../../Components/StandardTooltip";

const CancelBookingButton = (props) => {
    const dispatch = useDispatch();
    const tabState = useContext(TabContext);

    const [cancellationWindowElapsed, setCancellationWindowElapsed] = useState(false);

    /**
     * Set a timer to check every 15 seconds if the cancellation window has elapsed
     */
    useEffect(() => {
        if (!props.booking.payment?.cancellable_until) {
            return null;
        }

        const checkCancellationTime = () => {
            const currentTime = new Date();
            const target = new Date(props.booking.payment.cancellable_until);
            setCancellationWindowElapsed((currentTime >= target));
        };

        checkCancellationTime();

        // Set up interval to check every second
        const intervalId = setInterval(checkCancellationTime, 15000);

        // Clean up interval on component unmount
        return () => clearInterval(intervalId);
    }, [props.booking]);

    const getMenuItems = () => {
        return (props.booking.recurrence_id)
            ? {
                [UPDATE.SINGLE]: 'Cancel Single Occurrence',
                [UPDATE.SERIES_AFTER_EVENT]: 'Cancel This and Subsequent Occurrences',
                [UPDATE.SERIES]: 'Cancel Series',
            }
            : null;
    }

    const getMenuConfirmationText = () => {
        if (props.booking.recurrence_id) {
            return {
                [UPDATE.SINGLE]: {
                    title: "Cancel this booking",
                    text: "<p>Are you sure you want to cancel this booking occurrence?</p>"
                },
                [UPDATE.SERIES_AFTER_EVENT]: {
                    title: "Cancel this and subsequent bookings in series",
                    text: "<p>Are you sure you want to cancel this booking and every later occurrence in the series?</p>"
                },
                [UPDATE.SERIES]: {
                    title: "Cancel all bookings in series",
                    text: "<p>Are you sure you want to cancel all future bookings that are part of this series?</p>"
                },
            }
        };

        if (props.booking.payment?.id) {
            return {
                title: "Cancel Booking",
                text: "<p>Are you sure you want to cancel this booking? Refunds can take between 5-10 business days.</p>"
            };
        }

        return {
            title: "Cancel Booking",
            text: "<p>Are you sure you want to cancel this booking?</p>"
        };
    }

    const handleCancel = (updateType) => {
        dispatch(
            cancelBooking(props.booking.id, tabState.scope, tabState.view, updateType)
        );
    }

    if (!props.booking || !props.booking.can_archive) {
        return null;
    }

    const cancelButton =
        <ActionButton
            icon="fa-ban"
            className="cancel-booking"
            onClick={(evt) => handleCancel(UPDATE.SINGLE)}
            onMenuItemClick={(updateType) => { handleCancel(updateType)}}
            isDisabled={(props.booking.signed_in_at !== null || cancellationWindowElapsed)}
            menuItems={getMenuItems()}
            confirmationText={getMenuConfirmationText()}
        />;

    if (cancellationWindowElapsed) {
        const formattedDuration = formatDuration(props.booking.booked_config.cancellation_window)
        return (
            <StandardTooltip
                title={`This booking can no longer be cancelled as you are within ${formattedDuration} of the booking start time.`}
            >
                <div>{cancelButton}</div>
            </StandardTooltip>
        );
    }

    return cancelButton;
}

export default CancelBookingButton;
